<template> <b-row>
        <div class="col-sm-12 mt-3">
            <div class="texto-titulo-formulario">
                Sucursales
            </div>
        </div>

        <div class="col-sm-12 mt-3">
            <label for="" class="form-label">Filtro por empresa</label>
            <select class="form-control form-control-sm" v-model="empresa_seleccionada" @change="obtener_sucursales">
                <option value="">Seleccionar</option>
                <option v-for="empresa in empresas_disponibles" :key="empresa.id" :value="empresa.id">
                    {{ empresa.nombre }}
                </option>
            </select>
        </div>
        <div class="col-sm-12 mt-3">
            <div class="drag-drop-container">
                <div class="sucursales-list">
                    <!-- <h6>Sucursales Disponibles</h6> -->
                    <div class="texto-titulo-dd">
                        Sucursales Disponibles
                    </div>
                    <div class="sucursales-box" @dragover.prevent @drop="onDropDisponible">
                        <div v-for="sucursal in sucursalesDisponibles" :key="sucursal.id" draggable="true"
                            @dragstart="startDrag($event, sucursal)" class="sucursal-item">
                            {{ sucursal.nombre }} (ID: {{ sucursal.codigo }})
                        </div>
                    </div>
                </div>
                <div class="sucursales-arrows">
                    <!-- <button class="btn btn-sm btn-outline-dark" @click="moverTodosDerecha">
                        <i class="fas fa-angle-double-right"></i>
                    </button> -->
                    <button class="btn btn-sm btn-outline-dark mt-2" @click="moverTodosIzquierda">
                        <i class="fas fa-trash"></i>
                    </button>
                </div>
                <div class="sucursales-list">
                    <!-- <h6>Sucursales Asignadas</h6> -->
                    <div class="texto-titulo-dd">
                        Sucursales Asignadas
                    </div>
                    <div class="sucursales-box" @dragover.prevent @drop="onDropAsignada">
                        <div v-for="sucursal in sucursalesAsignadas" :key="sucursal.id" draggable="true"
                            @dragstart="startDrag($event, sucursal)" class="sucursal-item">
                            {{ sucursal.nombre }} (ID: {{ sucursal.codigo }})
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-3 mt-4 mb-3">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block" @click="volver">
                Anterior
            </button>
        </div>
        <div class="col-sm-9 mt-4 mb-3">
            <button v-if="sucursalesAsignadas.length != 0" type="button" class="btn btn-sm btn-outline-dark btn-block"
                @click="guardar_usuario">Guardar</button>
            <button v-else type="button" class="btn btn-sm btn-outline-dark btn-block" disabled>Guardar</button>
        </div>
    </b-row>
</template>

<script>
    import { minix } from '@/components/functions/alertas'
    import { mapActions, mapMutations, mapState } from 'vuex'

    export default {
        name: 'DadSucursales',
        computed: {
            ...mapState(['sucursales', 'objeto_usuario'])
        },
        data() {
            return {
                sucursalesDisponibles: [],
                sucursalesAsignadas: [],
                empresas_disponibles: [],
                empresa_seleccionada: '',
            }
        },
        methods: {
            startDrag(evt, sucursal) {
                evt.dataTransfer.dropEffect = 'move'
                evt.dataTransfer.effectAllowed = 'move'
                evt.dataTransfer.setData('sucursalId', sucursal.codigo.toString())
            },
            onDropDisponible(evt) {
                const sucursalId = evt.dataTransfer.getData('sucursalId')
                const sucursal = this.sucursalesAsignadas.find(s => s.codigo.toString() === sucursalId)
                if (sucursal) {
                    this.sucursalesAsignadas = this.sucursalesAsignadas.filter(s => s.codigo.toString() !== sucursalId)
                    this.sucursalesDisponibles.push(sucursal)
                }
            },
            onDropAsignada(evt) {
                const sucursalId = evt.dataTransfer.getData('sucursalId')
                const sucursal = this.sucursalesDisponibles.find(s => s.codigo.toString() === sucursalId)

                // Validar que no se exceda el número de empresas seleccionadas
                if (sucursal && this.objeto_usuario && this.objeto_usuario.datos_empresas) {
                    // Verificar si ya existe una sucursal para la misma empresa
                    const empresaSucursal = sucursal.empresa.toString();
                    const yaExisteSucursalParaEmpresa = this.sucursalesAsignadas.some(
                        s => s.empresa && s.empresa.toString() === empresaSucursal
                    );

                    if (yaExisteSucursalParaEmpresa) {
                        // Mostrar mensaje de error
                        minix({ icon: 'warning', mensaje: 'Solo puedes escoger una sucursal por empresa', tiempo: 3000 })
                        return; // Detener la ejecución
                    }

                    // Si no hay sucursal para esta empresa, continuar con la asignación
                    this.sucursalesDisponibles = this.sucursalesDisponibles.filter(s => s.codigo.toString() !== sucursalId)
                    this.sucursalesAsignadas.push(sucursal)
                }
            },
            moverTodosDerecha() {
                if (this.sucursalesDisponibles.length > 0) {
                    this.sucursalesAsignadas = [...this.sucursalesAsignadas, ...this.sucursalesDisponibles]
                    this.sucursalesDisponibles = []
                }
            },
            moverTodosIzquierda() {
                this.sucursalesAsignadas = []
                this.obtener_sucursales()
                // if (this.sucursalesAsignadas.length > 0) {
                //     this.sucursalesDisponibles = [...this.sucursalesDisponibles, ...this.sucursalesAsignadas]
                //     this.sucursalesAsignadas = []
                // }
            },
            async guardar_usuario() {
                let f = {
                    api: `usuario-empresas/r/usuario-empresa`,
                    formulario: {
                        ...this.objeto_usuario,
                        datos_sucursales: this.sucursalesAsignadas
                    }
                }


                await this.guardar_data(f)
                await this.obtener_lista_usuarios_panel()
                this.set_usuario_datos_principales({})
                this.set_usuario_datos_empresas([])
                this.set_usuario_datos_sucursales([])
                this.$emit('salir')

            },
            volver() {
                this.$emit('anterior')
            },
            async obtener_sucursales() {
                if (this.empresa_seleccionada != '') {
                    let f = {
                        api: `sucursales?filters[empresa][$eq]=${this.empresa_seleccionada}`,
                    }

                    let r = await this.obtener_data(f)
                    this.sucursalesDisponibles = r
                }
            },
            async obtener_empresas() {
                this.empresas_disponibles = this.objeto_usuario.datos_empresas
            },
            ...mapActions(['obtener_data', 'guardar_data', 'obtener_lista_usuarios_panel']),
            ...mapMutations(['set_usuario_datos_principales', 'set_usuario_datos_empresas', 'set_usuario_datos_sucursales'])
        },
        async mounted() {
            await this.obtener_empresas()
        },
    }
</script>

<style scoped>
    .drag-drop-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 1rem;
    }

    .sucursales-list {
        flex: 1;
    }

    .sucursales-box {
        border: 1px solid #dee2e6;
        border-radius: 4px;
        /* min-height: 200px; */
        height: 300px;
        padding: 0.5rem;
        background: #f8f9fa;
        overflow: auto;
    }

    .sucursal-item {
        padding: 0.5rem;
        margin: 0.25rem 0;
        background: white;
        border: 1px solid #dee2e6;
        border-radius: 4px;
        cursor: move;
    }

    .sucursal-item:hover {
        background: #579bd7;
    }

    .sucursales-arrows {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 1rem;
        margin-top: 120px;
    }

    .texto-titulo-formulario {
        font-size: 30px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .texto-titulo-dd {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 5px;
    }
</style>